/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemMultipleSelectionPropertyItem } from './formPagePropertyItemMultipleSelectionPropertyItem';
import { FormPagePropertyItemMultipleSelectionItemDefinitionErrorMessage } from './formPagePropertyItemMultipleSelectionItemDefinitionErrorMessage';


/**
 * 複数選択型のItemsの定義
 */
export interface FormPagePropertyItemMultipleSelectionItemDefinition { 
    type: FormPagePropertyItemMultipleSelectionItemDefinition.TypeEnum;
    properties: FormPagePropertyItemMultipleSelectionPropertyItem;
    /**
     * value が固定で入る
     */
    required: Array<string>;
    errorMessage: FormPagePropertyItemMultipleSelectionItemDefinitionErrorMessage;
}
export namespace FormPagePropertyItemMultipleSelectionItemDefinition {
    export type TypeEnum = 'object';
    export const TypeEnum = {
        Object: 'object' as TypeEnum
    };
}



